import React, { useEffect, useMemo } from 'react'
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import useBboxUpdateForGraphicsLayer from './useBboxUpdateForGraphicsLayer';
import MapView from '@arcgis/core/views/MapView';
import { DECLARATIONS_MIN_SCALE_TO_SHOW } from '../../../../App/useNotificationsLayer';
import { useTranslation } from 'react-i18next';

export default function useShowAllLajiFiObservationsLayer(view: MapView) {
    const { t, i18n } = useTranslation("observations");

    const allLajiFiObservationsLayer = useMemo(() =>
        new GraphicsLayer({
            title: "Kaikki Laji.fi-havainnot alueelta HUOM! Valitse suodattimista myös laji ja/tai kokoelma!",
            visible: false,
            minScale: DECLARATIONS_MIN_SCALE_TO_SHOW
        }), []);

    useBboxUpdateForGraphicsLayer(view, allLajiFiObservationsLayer);

    useEffect(() => {
        if (allLajiFiObservationsLayer) {
            allLajiFiObservationsLayer.title = t("kaikkiLajiFiHavainnotKerrosOtsikko");
        }
    }, [t, i18n.language]);

    return {
        allLajiFiObservationsLayer
    }
}